import React, { Component } from 'react'
import './SlideDrawer.css'
import Axios from 'axios'
import { NavLink } from 'react-router-dom'
import { IoIosLogOut } from 'react-icons/io'
import { BsPen, BsPerson, BsAppIndicator, BsCalendar } from 'react-icons/bs'
import { BiHome } from 'react-icons/bi'
import { API_URL } from '../../config'

class SlideDrawer3 extends Component {
  state = {
    products: [],
  }
  componentDidMount() {
    let search = window.location.search
    let query = new URLSearchParams(search)
    let ticketid = query.get('ticketid')
    let eventid = query.get('eventid')

    Axios.get('/api/select/payment/method?eventid=' + eventid + '&ticketid=' + ticketid).then(
      (res) => {
        const products = res.data
        this.setState({ products })
      }
    )
  }

  handleLogout = async () => {
    try {
      await fetch(`${API_URL}/apps/kscanner/logout.php`, {
        method: 'GET',
        credentials: 'include', // sends cookies like sessionId
      })

      // Clear local data and redirect
      localStorage.clear()
      window.location.href = '/login'
    } catch (error) {
      console.error('Logout failed:', error)
    }
  }

  render() {
    let drawerClasses = 'slide-drawer'
    if (this.props.show) {
      drawerClasses = 'slide-drawer open'
    }
    return (
      <div className={drawerClasses}>
        <div className="row">
          <div className="col-lg-12 p-0">
            <NavLink to="/dashboard" className="links" exact activeClassName="activeLink">
              <div className="col-lg-12 mobile-nav textLight ">
                <BiHome size={25} /> &nbsp;&nbsp;&nbsp;Dashboard
              </div>
            </NavLink>
          </div>
          <div className="col-lg-12 p-0">
            <NavLink to="/myevents" className="links" exact activeClassName="activeLink">
              <div className="col-lg-12 mobile-nav textLight">
                <BsCalendar size={25} /> &nbsp;&nbsp;&nbsp;My Events
              </div>
            </NavLink>
          </div>

          <div className="col-lg-12 p-0">
            <NavLink to="/profile" className="links" exact activeClassName="activeLink">
              <div className="col-lg-12 mobile-nav textLight">
                <BsPerson size={25} /> &nbsp;&nbsp;&nbsp;My Account
              </div>
            </NavLink>
          </div>

          <div className="col-lg-12 p-0">
            <NavLink to="/feedback" className="links" exact activeClassName="activeLink">
              <div className="col-lg-12 mobile-nav textLight">
                <BsPen size={25} /> &nbsp;&nbsp;&nbsp;Send feedback
              </div>
            </NavLink>
          </div>

          <div className="col-lg-12 p-0">
            <NavLink
              to={'#'}
              className="links"
              exact
              activeClassName="activeLink"
              onClick={this.handleLogout}
            >
              <div className="col-lg-12 mobile-nav textLight">
                <IoIosLogOut size={25} /> &nbsp;&nbsp;&nbsp;log out
              </div>
            </NavLink>
          </div>
        </div>
      </div>
    )
  }
}

export default SlideDrawer3
